import {UsersActionTypes} from '../Constants/UsersActionTypes';
import axios from 'axios';
import { GET_CAPTCHA, GET_REFRESH_CAPTCHA, GET_VALIDATE_SIGNUP, GET_CONTENT_DATA, GET_MATCHED_LANGUAGE_DATA } from '../../../Config/Api.route.config';
import { cmsDefault } from '../../../Constant/DefaultCMS';
import { glassboxErrorEvent } from '../../../Components/Service/Glassbox';

export const setUsers = (users) => {
    return{
        type:UsersActionTypes.SET_USERS,
        payload:users
    }
}

export const getCaptcha = () => {
    return async (dispatch) => {
        await axios.get(GET_CAPTCHA).then((res) => {
            const usersData = res.data;
            dispatch(setUsers(usersData))
        }).catch((error) => {
            console.log(error);
            glassboxErrorEvent(error);
        })
    }
}

export const refreshCaptcha = (key) => {
    return async (dispatch) => {
        
        await axios.get(GET_REFRESH_CAPTCHA + "/" + key ).then((res) => {
            const usersData = res.data;        
            dispatch(setUsers(usersData))
        }).catch((error) => {
            console.log(error);
            glassboxErrorEvent(error);
        })
    }
}

export const setValidateSignUp = (users) => {
    return {
        type: UsersActionTypes.SET_VALIDATE_SIGNUP,
        payload: users
    }
}

export const validateSignUp = (key, action) => {
    if (action !== "none") {
        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            data: JSON.stringify(key),
            url: GET_VALIDATE_SIGNUP + "/"
        };
        return async (dispatch) => {
            await (await axios(options).then((res) => {
                const usersData = res.data;
                dispatch(setValidateSignUp(usersData));
            }).catch((error) => {
                dispatch(setValidateSignUp(error.response.data));
                glassboxErrorEvent(error);
            }))

        }
    }
    else {
        return async (dispatch) => {
            dispatch(setValidateSignUp({}));
        }
    }
}

export const setContentData = (users) => {
    return {
        type: UsersActionTypes.SET_CONTENT_DATA,
        payload: users
    }
}

export const getContentData = (country, lang) => {
    return async (dispatch) => {
        await axios.get(GET_CONTENT_DATA + "/" + country + "/" + lang).then((res) => {
            if (res.data !== 0) {
                const usersData = res.data;
                dispatch(setContentData(usersData));
            }
            else {
                const usersData = cmsDefault;
                dispatch(setContentData(usersData));
            }
        }).catch((error) => {
            const usersData = cmsDefault;
            dispatch(setContentData(usersData));
            glassboxErrorEvent(error);
        })
    }
}

export const setMatchedLanguageData = (users) => {
    return {
        type: UsersActionTypes.SET_MATCHED_LANGUAGE_DATA,
        payload: users
    }
}

export const getMatchedLanguageData = (country, lang) => {
    return async (dispatch) => {
        await axios.get(GET_MATCHED_LANGUAGE_DATA + "/" + country + "/" + lang).then((res) => {
            const usersData = res.data;
            dispatch(setMatchedLanguageData(usersData))
        }).catch((error) => {
            console.log(error);
            glassboxErrorEvent(error);
        })
    }
}
